import {
  GET_PRODUCTS_PENDING,
  GET_PRODUCTS_FAIL,
  GET_PRODUCTS_SUCCESS,
} from '../actions/productActions';

const initialState = {
  loading: false,
  loaded: true,
  options: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_PRODUCTS_PENDING:
      return {
        loading: true,
        loaded: false,
      };
    case GET_PRODUCTS_SUCCESS: {
      const formatted = action.payload.map(l => ({ label: l.name, value: l.id }));
      return {
        loading: false,
        loaded: true,
        options: formatted,
      };
    }
    case GET_PRODUCTS_FAIL:
      return {
        loading: false,
        loaded: true,
        ...action.payload,
      };
    default:
      return state;
  }
}
